import React from 'react'
import PropTypes from 'prop-types'

const IconBase = ({ viewBox, size, color, style, children, ...rest }) => (
  <svg
    data-testid="svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    preserveAspectRatio="xMidYMid meet"
    width={size || '1em'}
    height={size || '1em'}
    {...rest}
    style={{
      verticalAlign: 'middle',
      color: color || 'currentColor',
      ...style
    }}
  >
    <g fill="currentColor">{children}</g>
  </svg>
)

IconBase.propTypes = {
  viewBox: PropTypes.string.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  style: PropTypes.object
}

export default IconBase
